import { render, staticRenderFns } from "./DocumentGray.vue?vue&type=template&id=dcf152c2&scoped=true"
import script from "./DocumentGray.vue?vue&type=script&lang=js"
export * from "./DocumentGray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf152c2",
  null
  
)

export default component.exports